import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FeatureInfoPrice from "./featureInfoPrice";
import FeatureInfoPriceLocked from "./featureInfoPriceLocked";
import FeatureInfoBrand from "./featureInfoBrand";
import FeatureInfoDescription from "./featureInfoDescription";
import FeatureInfoMaterial from "./featureInfoMaterial";
import FeatureName from "../../visComponents/featureName";

const FeatureInfoDesc = (props) => {

  const {activeFeature, showPrice, showPriceLocked, isMobile, fabricatorSettings} = props;

  return (
    <div>
      <h2 className="product-info__title bold"><FeatureName feature={activeFeature}/></h2>
      {activeFeature.dbFeature.sku && !fabricatorSettings.hideSku ? (
        <span className="product-info__price-model">
          <FormattedMessage id="quotingTool.featureInfo.skuNumber"/> {activeFeature.dbFeature.sku}
        </span>
      ) : null}
      <FeatureInfoPrice feature={activeFeature} showPrice={showPrice}/>
      {showPriceLocked ? <FeatureInfoPriceLocked /> : null}
      <FeatureInfoBrand feature={activeFeature}/>
      <FeatureInfoMaterial feature={activeFeature}/>
      {isMobile ? null : <FeatureInfoDescription feature={activeFeature}/>}
    </div>
  );
};

FeatureInfoDesc.displayName = 'FeatureInfoDesc';
FeatureInfoDesc.propTypes = {
  activeFeature: PropTypes.object,
  showPrice: PropTypes.bool,
  showPriceLocked: PropTypes.bool,
  isMobile: PropTypes.bool,
  fabricatorSettings: PropTypes.object,
};
export default FeatureInfoDesc;
